import { isPromise } from "./promise.js";
const firstTrue = (promises) => {
    const newPromises = promises.map((p) => new Promise((resolve, reject) => p.then((v) => v && resolve(true), reject)));
    newPromises.push(Promise.all(promises).then(() => false));
    return Promise.race(newPromises);
};
export const anymap = (f) => (xs) => {
    const promises = [];
    for (const x of xs) {
        const result = f(x);
        if (isPromise(result)) {
            promises.push(result);
            // @ts-expect-error cannot infer
        }
        else if (result)
            return true;
    }
    // @ts-expect-error cannot infer
    return (promises.length) ? firstTrue(promises) : false;
};
export const any = (a) => a.some((x) => x);
export const allmap = (f) => (xs) => {
    const promises = [];
    for (const x of xs) {
        const result = f(x);
        if (isPromise(result)) {
            promises.push(result);
            // @ts-expect-error cannot infer
        }
        else if (!result)
            return false;
    }
    // @ts-expect-error cannot infer
    return !promises.length ||
        firstTrue(promises.map((x) => x.then((x) => !x))).then((x) => !x);
};
export const all = (a) => a.every((x) => x);
export const join = (str) => (x) => x.join(str);
export const length = (array) => array.length;
// deno-lint-ignore no-explicit-any
export const uniqueBy = (key) => (array) => {
    const seen = new Set();
    const result = [];
    for (const x of array) {
        const k = key(x);
        if (!seen.has(k)) {
            result.push(x);
            seen.add(k);
        }
    }
    return result;
};
export const unique = (array) => Array.from(new Set(array));
export const concat = (array) => {
    const result = [];
    for (const xs of array) {
        for (const x of xs) {
            result.push(x);
        }
    }
    return result;
};
export const reverse = (array) => array.slice().reverse();
export const tail = (x) => x.slice(1);
// deno-lint-ignore no-explicit-any
export const head = (x) => x[0];
export const init = (x) => x.slice(0, -1);
// deno-lint-ignore no-explicit-any
export const second = (x) => x[1];
// deno-lint-ignore no-explicit-any
export const third = (x) => x[2];
export const last = (x) => x[x.length - 1];
export const empty = (x) => !x.length;
export const nonempty = (x) => !!x.length;
export const wrapArray = (x) => [x];
// deno-lint-ignore no-explicit-any
export const zip = (args) => range(0, Math.min(...args.map(length))).map((i) => args.map((arr) => arr[i]));
const compareArrays = (a, b) => {
    for (const [x, y] of zip([a, b])) {
        const result = comparator(x, y);
        if (result)
            return result;
    }
    return 0;
};
const comparator = (a, b) => typeof a === "boolean" && typeof b === "boolean"
    ? Number(a) - Number(b)
    : typeof a === "string" && typeof b === "string"
        ? a.localeCompare(b)
        : typeof a === "number" && typeof b === "number"
            ? a - b
            : compareArrays(a, b);
const castToInt = (x) => x === true ? 1 : x === false ? -1 : x;
export const sortCompare = (comparator) => (xs) => xs.slice().sort((x, y) => castToInt(comparator(x, y)));
export const sort = sortCompare(comparator);
export const sortKey = (key) => sortCompare((a, b) => comparator(key(a), key(b)));
export const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++)
        result.push(i);
    return result;
};
export const contains = (x) => (array) => array.includes(x);
export const includedIn = (array) => (x) => array.includes(x);
export const take = (n) => (xs) => xs.slice(0, n);
export const sample = (n) => (xs) => xs.slice()
    .map((value, index) => [Math.random(), value, index])
    .sort(([a], [b]) => a - b)
    .slice(0, Math.min(n, xs.length))
    .map(([, value]) => value);
export const drop = (n) => (xs) => xs.slice(n);
export const enumerate = (xs) => xs.map((x, i) => [i, x]);
export const slidingWindow = (l) => (xs) => xs.flatMap((_, i) => (i <= xs.length - l ? [xs.slice(i, i + l)] : []));
export const append = (element) => (arr) => [...arr, element];
